
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swing-trading-kit",
      function () {
        return require("private-next-pages/swing-trading-kit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swing-trading-kit"])
      });
    }
  